import React from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import PatientOption from "./PatientOption";
import PatientValue from "./PatientValue";

import { Async } from "react-select";

class PatientSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      patients: [],
      selectedPatientId: this.props.patientId,
      noResultsText:
        "Aucun résultat, entrez au moins 3 caractères ou 6 chiffres"
    };
  }

  getOptions = async (input, callback) => {
    let patientId = this.state.selectedPatientId;
    if (input.length > 2) {
      /*  const result = await this.props.client.query({
        query: PATIENTS_SEARCH_QUERY,
        variables: { filter: input }
      });
      callback(null, {
        options: result.data.allPatients,
        cache: false,
        complete: true
      });*/
      let parsed = parseInt(input, 10);
      let result = null;
      if (isNaN(parsed)) {
        result = await this.props.client.query({
          query: PATIENTS_SEARCH_QUERY,
          variables: { filter: input },
          fetchPolicy: "cache-first"
        });
      } else {
        //is a number
        if (input.length > 5) {
          result = await this.props.client.query({
            query: PATIENTS_SEARCH_QUERY_MATRICULE,
            variables: { filter: input },
            fetchPolicy: "cache-first"
          });
        }
      }
      if (result.data.allPatients.length > 10) {
        this.setState({
          noResultsText:
            "Trop de résultats, entrez plus de caractères ou de chiffres"
        });
        callback(null, {
          options: [],
          cache: true,
          complete: true
        });
      } else {
        this.setState({
          noResultsText:
            "Aucun résultat, entrez au moins 3 caractères ou 6 chiffres"
        });
        callback(null, {
          options: result.data.allPatients,
          cache: true,
          complete: true
        });
      }
    } else if (input.length === 0 && patientId) {
      const result = await this.props.client.query({
        query: PATIENTS_SEARCH_BY_ID,
        variables: { patientId: patientId }
      });
      //  this.setState({ selectedPatient: result.data.Patient });
      callback(null, {
        options: [result.data.Patient],
        complete: true
      });
    } else {
      callback(null, {
        options: [],
        cache: false,

        complete: true
      });
    }
  };

  filterOptions = (options, filter, currentValues) => {
    return options;
  };
  handleChangePatient = value => {
    this.props.changePatient(value.id);

    this.setState({
      selectedPatientId: value.id
    }); /*, async () => {
      const id = this.props.slotId;
      const patientId = value.id;

      await this.props
        .updateSlotMutation({
          variables: { id, patientId }
        })
        .catch(e => {
          console.error("update slot", e);
        });
    });*/
  };

  render() {
    return (
      <Async
        autoBlur={true}
        loadOptions={this.getOptions}
        autoload={true}
        onBlurResetsInput={false}
        onCloseResetsInput={false}
        searchPromptText="Entrez au moins 6 caractères ou chiffres"
        noResultsText={this.state.noResultsText} //"Aucun résultat, entrez au moins 3 caractères ou chiffres"
        loadingPlaceholder="Chargement..."
        cache={false}
        onSelectResetsInput={false}
        //deleteRemoves={false}
        //  backspaceRemoves={false}
        name="form-field-name"
        placeholder="Cherchez un patient"
        value={this.state.selectedPatientId}
        options={this.state.patients}
        labelKey="nom"
        openOnClick={false}
        valueKey="id"
        matchProp="any"
        clearable={false}
        onChange={v => this.handleChangePatient(v)}
        optionComponent={PatientOption}
        valueComponent={PatientValue}
        filterOptions={this.filterOptions}
      />
    );
  }
}
const PATIENTS_SEARCH_BY_ID = gql`
  query getPatientById($patientId: ID!) {
    Patient(id: $patientId) {
      id
      nom
      prenom
      matricule
      telephone
    }
  }
`;
const PATIENTS_SEARCH_QUERY_MATRICULE = gql`
  query AllPatientsQueryMatricule($filter: String!) {
    allPatients(
      orderBy: nom_ASC
      filter: { OR: [{ matricule_starts_with: $filter }] }
    ) {
      id
      nom
      prenom
      matricule
    }
  }
`;
const PATIENTS_SEARCH_QUERY = gql`
  query AllPatientsQuery($filter: String!) {
    allPatients(
      orderBy: nom_ASC
      filter: { OR: [{ nom_starts_with: $filter }] }
    ) {
      id
      nom
      prenom
      matricule
    }
  }
`;

export default withApollo(PatientSelect);



// WEBPACK FOOTER //
// ./src/components/utilities/PatientSelect.js